export default "__VITE_ASSET__BcE2sQov__"